import React from 'react';
import {View} from 'react-native';
import {TimeProps} from 'react-native-gifted-chat';
import {
  ActivityIndicator,
  Icon,
  Text,
  useTheme,
} from 'react-native-paper';
import {ChatMessage} from '../../../types';

export function ChatBubbleTime({
  timeProps,
  chatId,
}: {
  timeProps: TimeProps<ChatMessage>;
  chatId: string;
}) {
  const theme = useTheme();

  const time =
    timeProps.currentMessage &&
    new Date(timeProps.currentMessage.createdAt).toLocaleString(
      'en-US',
      {
        hour: 'numeric',
        minute: 'numeric',
        hourCycle: 'h24',
      },
    );
  const userName = timeProps.currentMessage?.userName;
  let chatBubbleStatusIcon = timeProps.currentMessage?.received
    ? 'check-all'
    : 'check';
  let chatBubbleStatusIconColor = timeProps.currentMessage?.received
    ? 'green'
    : 'white';
  if (timeProps.currentMessage?.error) {
    chatBubbleStatusIcon = 'close';
    chatBubbleStatusIconColor = 'red';
  }

  return (
    <View style={{position: 'absolute', top: 20, height: 40}}>
      <Text
        style={{
          color: theme.colors.onSurface,
          fontSize: theme.fonts.labelSmall.fontSize,
          fontWeight: theme.fonts.labelSmall.fontWeight,
          letterSpacing: theme.fonts.labelSmall.letterSpacing,
          left: timeProps.position === 'left' ? -14 : 14,
          height: 40,
          width: 200,
          textAlign: timeProps.position,
          overflow: 'visible',
        }}>
        {`${userName}, ${time}`}
        {timeProps.currentMessage?.pending ? (
          <ActivityIndicator
            style={{paddingLeft: 3, paddingTop: 0}}
            size={12}
          />
        ) : (
          <Icon
            source={chatBubbleStatusIcon}
            size={12}
            color={chatBubbleStatusIconColor}
          />
        )}
      </Text>
    </View>
  );
}
